<pagination-template class="paginationSty" #p="paginationApi" [id]="config.id" *ngIf="total>limit"
    (pageChange)="config.currentPage = $event">
    <div style="color: #aaabac;" *ngIf="custompageInfo">
      <p style="text-align: right; margin-top: 0px;" *ngIf="config.currentPage!==totalPages">Showing
        {{((config.currentPage-1)*limit)+1}} to {{config.currentPage*limit}} of {{total}} entries</p>
      <p style="text-align: right; margin-top: 0px;" *ngIf="config.currentPage===totalPages">Showing
        {{((config.currentPage-1)*limit)+1}} to {{total}} of {{total}} entries</p>
    </div>
    <ul class="custom-pagination float-right">
      <li class="paginator-nav-btns" style="border-bottom-left-radius: 5px;border-top-left-radius: 5px;"
        [ngClass]="{'disableNav': config.currentPage===1}" (click)="getSearchOrCollectionData(1)">
        <a> <i class="fa fa-angle-double-left" style="font-weight: 900;"></i> </a>
      </li>
      <li class="paginator-nav-btns" [ngClass]="{'disableNav': config.currentPage===1}"
        (click)="getSearchOrCollectionData(config.currentPage-1)">
        <a> <i class="fa fa-angle-left bold" style="font-weight: 900;"></i> </a>
      </li>
      <ul *ngFor="let page of pageObject">
        <li class="paginator-nav-btns" [ngClass]="{'activePage': page.selected}"
          (click)="getSearchOrCollectionData(page.pageNum)"
          *ngIf="config.currentPage===page.pageNum+1||config.currentPage===page.pageNum||config.currentPage===page.pageNum-1">
          <a>{{page.pageNum}}</a>
        </li>
      </ul>

      <li class="paginator-nav-btns" [ngClass]="{'disableNav': config.currentPage===totalPages}"
        (click)="getSearchOrCollectionData(config.currentPage+1)">
        <a> <i class="fa fa-angle-right" style="font-weight: 900;"></i> </a>
      </li>
      <li class="paginator-nav-btns" style="border-bottom-right-radius: 5px;border-top-right-radius: 5px;"
        [ngClass]="{'disableNav': config.currentPage===totalPages}"
        (click)="getSearchOrCollectionData(totalPages)">
        <a> <i class="fa fa-angle-double-right" style="font-weight: 900;"></i> </a>
      </li>
    </ul>
</pagination-template>